// extracted by mini-css-extract-plugin
export var container = "header-module--container--XLnQW";
export var icon = "header-module--icon--JPvyr";
export var appName = "header-module--appName--3K1ND";